import { FeatureFlagService, FeatureFlag } from '../services/FeatureFlagService';
import { SessionManagementService } from '../services/SessionManagementService';

export function isMetricsEnabled(): boolean {
  const sessionManagementService = SessionManagementService.instance;
  return sessionManagementService.metricsOnSiteEnabled() && FeatureFlagService.instance.getValue(FeatureFlag.metricsSpaceEnabled);
}
